export default __webpack_public_path__ + "static/media/data_setting_2.cc5d58d8.png";